enum ImportType {
  NO_UID = 'no_uid',
  UID = 'uid',
  SUPPORT = 'support',
}

export default ImportType;
